import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { END_POINT_LLM_SERVICE } from '@/constants';

type CodeSnippetProps = {
  model: string;
  apiKey?: string;
  endpoint?: string;
};
const CodeLangchain = ({
  model,
  apiKey = '<your API key>',
  endpoint = END_POINT_LLM_SERVICE
}: CodeSnippetProps) => {
  return (
    <div className="flex flex-col gap-2">
      <li>Install the LangChain package:</li>
      <SyntaxHighlighter language="auto" wrapLongLines showCopy>
        {`pip install langchain langchain_community`}
      </SyntaxHighlighter>
      <p>or</p>
      <SyntaxHighlighter language="auto" wrapLongLines showCopy>
        {`conda install langchain langchain_community -c conda-forge`}
      </SyntaxHighlighter>
      <li>Use the following Python code snippet:</li>
      <SyntaxHighlighter language="python" wrapLongLines showCopy>
        {`from langchain_community.chat_models import ChatOpenAI
from langchain.schema import HumanMessage

FLOAT16_BASE_URL = "${endpoint}"
FLOAT16_API_KEY = "${apiKey}"

chat = ChatOpenAI(
    model="${model}",
    api_key=FLOAT16_API_KEY,
    base_url=FLOAT16_BASE_URL,
    streaming=True,
)

# Simple invocation:
print(chat.invoke([HumanMessage(content="Hello")]))

# Streaming invocation:
for chunk in chat.stream("Write me a blog about how to start to raise cats"):
    print(chunk.content, end="", flush=True)`}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeLangchain;
